import instance from './testing.instance';

export const getInitialEndDate = (range) => instance.get(`/catalogo/get_range_from_to_datetimes?range=${range}`)